import { render } from "./PokemonPicture.vue?vue&type=template&id=e4d77e0e&scoped=true"
import script from "./PokemonPicture.vue?vue&type=script&lang=js"
export * from "./PokemonPicture.vue?vue&type=script&lang=js"

import "./PokemonPicture.vue?vue&type=style&index=0&id=e4d77e0e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e4d77e0e"

export default script